import React from "react";
import Portal from "@material-ui/core/Portal";
import { Notification } from "react-admin";

/**
 * React-admin Layout usa zIndex: 1 y el Snackbar no usa Portal,
 * por eso las toasts quedan debajo de Dialog/Modal (zIndex ~1300).
 * Renderizamos la notificación en document.body por encima de los modales.
 */
const MyNotification = (props) => (
  <Portal container={document.body}>
    <Notification {...props} style={{ zIndex: 14000 }} />
  </Portal>
);

export default MyNotification;



// WEBPACK FOOTER //
// ./src/components/MyNotification.js